import React, { useEffect, useState } from 'react';
import ConfirmationDialog from '../ConfirmationDialog.js';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { addNewSeller } from '../../../Redux/SellerRedux.js';
import { Country, State, City } from 'country-state-city';
import Select from 'react-select';

const AddSeller = ({ setShowForm }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);

  const initialSellerData = {
    firstName: '',
    lastName: '',
    gender: '',
    emailId: '',
    phoneNumber: '',
    companyName: '',
    street: '',
    townOrCity: '',
    state: '',
    country: '',
    pincode: '',
    landMark: '',
  };
  const [sellerData, setSellerData] = useState(initialSellerData);
  const { selectedSeller } = useSelector((state) => state.sellerRedux);

  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  const cityOptions =
    selectedCountry && selectedState
      ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
          (city) => ({
            label: city.name,
            value: city.name,
          })
        )
      : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSellerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSellerSubmit = (e) => {
    e.preventDefault();
    setConfirmDialog(true);
  };

  const handleClose = () => {
    resetForm();
    setShowForm(false);
    setConfirmDialog(false);
    setViewDetails(false);
    localStorage.setItem('vM', 'false');
  };

  useEffect(() => {
    const isViewMode = localStorage.getItem('vM');
    if (isViewMode === 'true' && selectedSeller) {
      setViewDetails(true);
      setSellerData({
        displayName: selectedSeller.displayName || '',
        firstName: selectedSeller.firstName || '',
        lastName: selectedSeller.lastName || '',
        gender: selectedSeller.gender || '',
        emailId: selectedSeller.emailId || '',
        phoneNumber: selectedSeller.phoneNumber || '',
        companyName: selectedSeller.address?.[0]?.companyName || '',
        street: selectedSeller.address?.[0]?.street || '',
        country: selectedSeller.address?.[0]?.country || '',
        state: selectedSeller.address?.[0]?.state || '',
        city: selectedSeller.address?.[0]?.townOrCity || '',
        pincode: selectedSeller.address?.[0]?.pincode || '',
        landMark: selectedSeller.address?.[0]?.landMark || '',
      });
      setViewDetails(true);
    }
  }, [dispatch, setShowForm, selectedSeller, viewDetails]);

  // const handleCountryChange = (val) => {
  //   setSellerData((prevState) => ({ ...prevState, country: val, state: '' }));
  // };

  // const handleStateChange = (val) => {
  //   setSellerData((prevState) => ({ ...prevState, state: val }));
  // };

  const handleSelectChange = (e) => {
    setSellerData({
      ...sellerData,
      gender: e.target.value,
    });
  };

  const confirmAddSeller = () => {
    const createSellerData = {
      firstName: sellerData.firstName,
      lastName: sellerData.lastName,
      gender: sellerData.gender,
      emailId: sellerData.emailId,
      phoneNumber: sellerData.phoneNumber,
      companyName: sellerData.companyName,
      street: sellerData.street,
      townOrCity: sellerData.townOrCity,
      state: sellerData.state,
      country: sellerData.country,
      pincode: sellerData.pincode,
      landMark: sellerData.landMark,
    };
    if (
      !sellerData.firstName ||
      !sellerData.lastName ||
      !sellerData.gender ||
      !sellerData.emailId ||
      !sellerData.phoneNumber ||
      !sellerData.companyName ||
      !sellerData.street ||
      !sellerData.townOrCity ||
      !sellerData.state ||
      !sellerData.country ||
      !sellerData.pincode ||
      !sellerData.landMark
    ) {
      toast.error('Please fill in all  fields to create sellerData.');
      setConfirmDialog(false);
      return;
    }
    dispatch(addNewSeller(user.userId, createSellerData));
    resetForm();
    setConfirmDialog(false);
    setShowForm(false);
  };

  const resetForm = () => {
    setSellerData(initialSellerData);
  };
  return (
    <>
      <div className='m-3'>
        <h5 className='text-center'>
          {!viewDetails ? 'Add Seller' : 'Seller Details'}
        </h5>
        <div style={{ padding: '25px' }}>
          <form>
            <div className='row d-flex justify-content-center'>
              <div className='col-4'>
                <label htmlFor='firstName'>
                  First Name <span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='text'
                  value={sellerData.firstName}
                  onChange={handleChange}
                  id='firstName'
                  name='firstName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-4'>
                <label htmlFor='lastName'>
                  Last Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='text'
                  value={sellerData.lastName}
                  onChange={handleChange}
                  id='lastName'
                  name='lastName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              {viewDetails && (
                <div className='col-4'>
                  <label htmlFor='displayName'>
                    Display Name<span className='requiredAsterisk'>*</span>
                  </label>
                  <input
                    type='text'
                    value={sellerData.displayName}
                    onChange={handleChange}
                    id='displayName'
                    name='displayName'
                    className='form-control mb-3'
                    style={{ border: '1px solid #cccccc' }}
                    required
                    readOnly
                  />
                </div>
              )}
              <div className='col-4'>
                <label htmlFor='gender'>
                  Gender <span className='requiredAsterisk'>*</span>
                </label>
                <select
                  id='gender'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  value={sellerData.gender}
                  onChange={handleSelectChange}
                  disabled={viewDetails}
                >
                  <option value='' disabled>
                    Select Gender
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                </select>
              </div>
              <div className='col-4'>
                <label htmlFor='emailId'>
                  Email Id<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={sellerData.emailId}
                  onChange={handleChange}
                  id='emailId'
                  name='emailId'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-4'>
                <label htmlFor='phoneNumber'>
                  Phone Number<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='tel'
                  id='phoneNumber'
                  className='form-control mb-3'
                  name='phoneNumber'
                  style={{ border: '1px solid #cccccc' }}
                  value={sellerData.phoneNumber}
                  onChange={handleChange}
                  // maxLength={4}
                  pattern='[0-9]*'
                  readOnly={viewDetails}
                />
              </div>
            </div>
            <div className='row mt-3'>
              <div className='col-12'>
                <h5 style={{ color: 'var(--primary-color)' }}>
                  Company Details
                </h5>
              </div>
              <div className='col-6'>
                <label htmlFor='companyName'>
                  Company Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={sellerData.companyName}
                  onChange={handleChange}
                  id='companyName'
                  name='companyName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <label htmlFor='street'>
                  Street Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={sellerData.street}
                  onChange={handleChange}
                  id='street'
                  name='street'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <div className='form-group mb-3'>
                  <label>
                    Country<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={countryOptions}
                      value={selectedCountry}
                      onChange={(option) => {
                        setSelectedCountry(option);
                        setSelectedState(null);
                        setSelectedCity(null);
                        setSellerData((prevData) => ({
                          ...prevData,
                          country: option.label,
                        }));
                      }}
                      placeholder='Select country'
                    />
                  ) : (
                    <input
                      type='text'
                      value={sellerData.country}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>
              <div className='col-6'>
                <div className='form-group mb-3'>
                  <label>
                    State<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={stateOptions}
                      value={selectedState}
                      onChange={(option) => {
                        setSelectedState(option);
                        setSelectedCity(null);
                        setSellerData((prevData) => ({
                          ...prevData,
                          state: option.label,
                        }));
                      }}
                      placeholder='Select state'
                      isDisabled={!selectedCountry}
                    />
                  ) : (
                    <input
                      type='text'
                      value={sellerData.state}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>

              <div className='col-4'>
                <div className='form-group mb-3'>
                  <label>
                    City<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={cityOptions}
                      value={selectedCity}
                      onChange={(option) => {
                        setSelectedCity(option);
                        setSellerData((prevData) => ({
                          ...prevData,
                          townOrCity: option.label,
                        }));
                      }}
                      placeholder='Select city'
                      isDisabled={!selectedState}
                    />
                  ) : (
                    <input
                      type='text'
                      value={sellerData.city}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>
              <div className='col-3'>
                <label htmlFor='pincode'>
                  Pincode<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={sellerData.pincode}
                  onChange={handleChange}
                  id='pincode'
                  name='pincode'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-5'>
                <label htmlFor='landMark'>
                  Landmark<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={sellerData.landMark}
                  onChange={handleChange}
                  id='landMark'
                  name='landMark'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
            </div>

            <div className='row d-flex justify-content-center'>
              <div className='col-6 text-center'>
                {!viewDetails ? (
                  <button
                    className='btn w-100'
                    style={{
                      background: '#2b6930',
                      color: '#fff',
                      padding: '10px',
                    }}
                    onClick={handleSellerSubmit}
                  >
                    Create
                  </button>
                ) : (
                  <button
                    className='btn w-100'
                    style={{
                      background: '#C0000B',
                      color: '#fff',
                      padding: '10px',
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleClose}
        onConfirm={confirmAddSeller}
        description='Are you sure you want to add this sellerData?'
      />
    </>
  );
};

export default AddSeller;
